import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getSubAdminInfo, updateAdmin } from "../Redux/Action/AuthAction";
import SubAdminForm from "../Component/SubAdminForm";

import { toast } from "react-toastify";

export default function EditSubAdmin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [initialValues, setInitialValues] = useState(null);
  
  const currentUser = useSelector((state) => state.SubAdmin.admindetails);

  useEffect(() => {
    dispatch(getSubAdminInfo(id)).then(function (info) {
      if (info?.payload?.data) {
        const data = info.payload.data;
        
        // Security Check: Sub-Admins cannot edit Admin users or Blocked users
        if (currentUser?.role === 'Sub-Admin') {
          if (data.role === 'Admin' && data._id !== currentUser._id) {
            toast.error("You do not have permission to edit a Super Admin account.");
            navigate('/sub-admin-management');
            return;
          }
          if (data.isActive === false) {
            toast.error("You do not have permission to edit a blocked administrator.");
            navigate('/sub-admin-management');
            return;
          }
        }

        setInitialValues({
          name: data.name || "",
          email: data.email || "",
          role: data.role || "",
          permission: data.permission || [],
          isActive: data.isActive !== false, // Default to true if not explicitly false
        });
      }
    });
  }, [id, dispatch]);

  const handleSubmit = (value) => {
    value.id = id;
    return dispatch(updateAdmin(value)).then(function () {
      navigate("/sub-admin-management");
    });
  };

  return (
    <Layout>
      <div className="dashboard_data_wrap sub-admin-management">
        <div className="dashbord_cont_wrapper">
          {initialValues ? (
            <SubAdminForm 
              initialValues={initialValues} 
              onSubmit={handleSubmit} 
              isEdit={true} 
            />
          ) : (
            <div style={{ padding: '50px', textAlign: 'center' }}>Loading Admin Details...</div>
          )}
        </div>
      </div>
    </Layout>
  );
}
